import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AuthService } from '../core/auth.service';

@Component({
  selector: 'app-login',
  template: `
    <div class="card login-panel">
      <div class="card-img-top user-image text-center">
        <i class="fa fa-user-circle"></i>
      </div>
      <form class="p-3" #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
        <div class="form-group">
          <input type="text" class="form-control" [(ngModel)]="loginModel.username" name="username" required placeholder="Username">
        </div>
        <div class="form-group">
          <input type="password" class="form-control" [(ngModel)]="loginModel.password" name="password" required placeholder="Password">
        </div>
        <div class="form-group">
          <input type="text" class="form-control" [(ngModel)]="loginModel.company" name="company" required placeholder="Company">
        </div>
        <button type="submit" class="btn btn-primary btn-block" [disabled]="loginForm.form.invalid">Login</button>
        <div class="form-group text-center login-or">
          <span>------------ or ------------</span>
        </div>
        <button type="button" class="btn btn-primary btn-block" (click)="submitSSOLogin()" [disabled]="!isSSOUrlLoaded()">Single Sign-On</button>
      </form>
    </div>
  `,
  styles: [`
    :host {
      height: 100%;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
      background-color: #aaa;
    }
    .login-panel {
      background-color: #fff;
      width: 300px;
    }
    .user-image {
      font-size: 6rem;
    }
    .login-or {
      margin-top: 10px
    }
  `]
})
export class LoginComponent {

  loginModel: any = {};

  constructor(
    private router: Router,
    private notificationsService: NotificationsService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.authService.InitializeAuthService();
  }

  onSubmit(loginForm) {
    let { username, password, company } = this.loginModel;
    this.authService.login(username, password, company).then((success) => {
      if (success) {
        this.router.navigate(['/']);
      } else {
        this.notificationsService.error('Login failed');
      }
    });
  }

  submitSSOLogin(){
    var redirectUrl = window.location.href.replace("login", "loginSSO");
    this.authService.ssoAuthService.authenticate(redirectUrl).then(
      (res: any) => {
        this.router.navigate(['loginSSO']);
      },
      (err) => {
        this.notificationsService.error(err.message);
      }
    );
  }

  isSSOUrlLoaded() {
    if(AuthService.ssoAuthenticationUrl) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts